import AcceptedBundIcon from 'assets/icons/AcceptedBundIcon.png';
import ActiveBundIcon from 'assets/icons/ActiveBundIcon.png';
import InactiveBundIcon from 'assets/icons/InactiveBundIcon.png';
import RejectedBundIcon from 'assets/icons/RejectedBundIcon.png';
import ActiveAcceptedBundIcon from 'assets/icons/ActiveAcceptedBundIcon.png';
import ActiveRejectedBundIcon from 'assets/icons/ActiveRejectedBundIcon.png';

import AcceptedPipeIcon from 'assets/icons/AcceptedPipeIcon.png';
import ActivePipeIcon from 'assets/icons/ActivePipeIcon.png';
import InactivePipeIcon from 'assets/icons/InactivePipeIcon.png';
import RejectedPipeIcon from 'assets/icons/RejectedPipeIcon.png';
import ActiveAcceptedPipeIcon from 'assets/icons/ActiveAcceptedPipeIcon.png';
import ActiveRejectedPipeIcon from 'assets/icons/ActiveRejectedPipeIcon.png';

import ActivePolygonIcon from 'assets/icons/ActivePolygonIcon.png';
import DrawnPolygonIcon from 'assets/icons/DrawnPolygonIcon.png';
import NeighbouringPolygonMachineGenerated from 'assets/icons/NeighbouringPolygonMachineGenerated.png';
import NeighbouringUserGeneratedPointIcon from 'assets/icons/NeighbouringUserGeneratedPointIcon.png';
import CompletedGeofence from 'assets/icons/CompletedGeofence.png';

const LEGEND_GROUP_1 = [
	{
		title: 'Inside The Plot Image Status',
		icons: [
			{
				title: 'Focused',
				iconUrl: ActiveBundIcon,
				height: 32,
				width: 32,
			},
			{
				title: 'Unfocused',
				iconUrl: InactiveBundIcon,
				height: 20,
				width: 20,
			},
			{
				title: 'Approved Unfocused',
				iconUrl: AcceptedBundIcon,
				height: 24,
				width: 28,
			},
			{
				title: 'Rejected Unfocused',
				iconUrl: RejectedBundIcon,
				height: 24,
				width: 28,
			},
			{
				title: 'Approved Focused',
				iconUrl: ActiveAcceptedBundIcon,
				height: 32,
				width: 32,
			},
			{
				title: 'Rejected Focused',
				iconUrl: ActiveRejectedBundIcon,
				height: 32,
				width: 32,
			},
		],
	},
	{
		title: 'Pipe Image Status',
		icons: [
			{
				title: 'Focused',
				iconUrl: ActivePipeIcon,
				height: 32,
				width: 32,
			},
			{
				title: 'Unfocused',
				iconUrl: InactivePipeIcon,
				height: 20,
				width: 20,
			},
			{
				title: 'Approved Unfocused',
				iconUrl: AcceptedPipeIcon,
				height: 24,
				width: 28,
			},
			{
				title: 'Rejected Unfocused',
				iconUrl: RejectedPipeIcon,
				height: 24,
				width: 28,
			},
			{
				title: 'Approved Focused',
				iconUrl: ActiveAcceptedPipeIcon,
				height: 32,
				width: 32,
			},
			{
				title: 'Rejected Focused',
				iconUrl: ActiveRejectedPipeIcon,
				height: 32,
				width: 32,
			},
		],
	},
	{
		title: 'Polygon',
		icons: [
			{
				title: 'Selected',
				iconUrl: ActivePolygonIcon,
				height: 24,
				width: 24,
			},
			{
				title: 'Completed',
				iconUrl: DrawnPolygonIcon,
				height: 24,
				width: 24,
			},
		],
	},
];
const LEGEND_GROUP_2 = [
	{
		title: 'Neighbouring Farm (User Generated)',
		icons: [
			{
				title: 'Image Location',
				iconUrl: NeighbouringUserGeneratedPointIcon,
				height: 16,
				width: 16,
			},
			{
				title: 'Farm Polygon',
				iconUrl: CompletedGeofence,
				height: 24,
				width: 24,
			},
		],
	},
	{
		title: 'Neighbouring Farm (Machine Generated)',
		icons: [
			{
				title: 'Farm Polygon',
				iconUrl: NeighbouringPolygonMachineGenerated,
				height: 24,
				width: 24,
			},
		],
	},
];

export const ALL_LEGENDS_DATA = [LEGEND_GROUP_1, LEGEND_GROUP_2];
